export default "__VITE_ASSET__BNoQf8s6__"